import React, { useEffect, useState } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
// import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import ReactTable from 'components/ReactTable/ReactTable';
import { Toasty, useToasty } from 'hooks/Toasty';
import { wsFindBy } from 'services/WService';
import RegularButton from 'components/CustomButtons/Button';
import { Visibility } from '@material-ui/icons';
import { useNavigate } from 'react-router-dom';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 85 },
  { Header: 'Cod.Socio', accessor: 'CardCode', width: 120, excelEnabled: false, align: 'center' },
  { Header: 'Socio', accessor: 'CardName', width: 500, excelEnabled: false },
  { Header: 'Fecha', accessor: 'RefDate', excelEnabled: false },
  { Header: 'Documentos', accessor: 'DocumentCount', excelEnabled: false },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 1 },
];

function ReconciliationList() {
  const [notify, showNotify] = useToasty();
  const [filter, setFilter] = useState({});
  const navigate = useNavigate();

  const [reconciliations, setReconciliations] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function listReconciliations() {
    setDataLoading(true);
    let res = await wsFindBy('pymt/reconciliation/customers', filter);
    setDataLoading(false);
    if (res.success) {
      setReconciliations(res.data);
    }
  }

  function navigateDetail(reconciliation) {
    navigate(
      `/admin/bancos/operaciones/reconciliacion/${reconciliation.CardCode}?RefDate=${reconciliation.RefDate}`,
    );
  }

  useEffect(() => {
    listReconciliations();
  }, []);

  return (
    <CardContainer /*title="Reconciliación pendientes"*/ title ={(<>Reconciliación pendientes{dataLoading && <LoadingSpinner />}</>)}>
      <Toasty action={notify} />
      {/* <FilterCustom dateRange diffRange={7} getFilter={setFilter} /> */}
      <ReactTable
        columns={columns}
        formatDate="DD-MM-YYYY"
        data={reconciliations.map((reconciliation, index) => {
          return {
            num: (
              <div className="actions-right">
                {index + 1}
                <RegularButton
                  justIcon
                  round
                  simple
                  color="primary"
                  onClick={() => navigateDetail(reconciliation)}
                >
                  <Visibility />
                </RegularButton>
              </div>
            ),
            ...reconciliation,
          };
        })}
      />
    </CardContainer>
  );
}

export default ReconciliationList;
